"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.book = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const book = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'book-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, rest),
        react_1.default.createElement("path", { "fill-rule": 'evenodd', "clip-rule": 'evenodd', d: 'M3.5 4.05951C2.80964 4.05951 2.25 4.61915 2.25 5.30951V5.58478C1.9407 5.90041 1.75 6.3327 1.75 6.80952V15.0952C1.75 16.0617 2.5335 16.8452 3.5 16.8452H7.73676C7.7992 16.8452 7.85937 16.8686 7.90545 16.9107L8.81915 17.7461C9.48773 18.3574 10.5123 18.3574 11.1808 17.7461L12.0945 16.9107C12.1406 16.8686 12.2008 16.8452 12.2632 16.8452H16.5C17.4665 16.8452 18.25 16.0617 18.25 15.0952V6.80952C18.25 6.33269 18.0593 5.90041 17.75 5.58477V5.30951C17.75 4.61915 17.1904 4.05951 16.5 4.05951H12.1582C11.7003 4.05951 11.2607 4.23897 10.9336 4.55938L10 5.4739L9.06643 4.55938C8.73934 4.23897 8.29969 4.05951 7.84181 4.05951H3.5ZM3.75 14.3452V5.55951H7.84181C7.90722 5.55951 7.97003 5.58515 8.01676 5.63092L9.25 6.83899V15.0249L8.55614 14.3452H3.75ZM10.75 15.0249L11.4439 14.3452H16.25V5.55951H12.1582C12.0928 5.55951 12.03 5.58515 11.9832 5.63092L10.75 6.83899V15.0249Z', fill: '#4B5563' })));
};
exports.book = book;
